export default "__VITE_ASSET__CgSns2H8__"